import { supabase } from 'src/services/supabase-client';
import { Weight, WeightEntity } from '../types/weight';
import { getWeek } from 'date-fns';

export type GetWeightsResponse = {
  weights: Weight[];
  streak: number;
};

export const getWeights = async (): Promise<GetWeightsResponse> => {
  let { data, error } = await supabase
    .from<WeightEntity>('weights')
    .select('id,date,weight,calories')
    .filter('deleted', 'eq', false)
    .order('date', { ascending: false });

  if (error) throw error;

  if (!data) return { weights: [], streak: 0 };

  let response = data.map(
    (d) => ({ ...d, date: new Date(d.date), bordered: false } as Weight)
  );

  for (let i = 1; i < response.length; i++) {
    if (
      getWeek(response[i].date, { weekStartsOn: 1 }) !==
      getWeek(response[i - 1].date, { weekStartsOn: 1 })
    )
      response[i - 1].bordered = true;
  }

  return {
    weights: response,
    streak: getStreak(response),
  };
};

const getStreak = (weights: Weight[]) => {
  let streak = 0;

  for (let i = 0; i < weights.length; i++) {
    if (weights[i].calories) streak++;
    else break;
  }

  return streak;
};
